// extracted by mini-css-extract-plugin
export default {"status":"Status_status__t4Lv6"};